import React from "react";
import { ArrayInput, SimpleFormIterator, SelectInput, required, PasswordInput } from 'react-admin';
import {
  EditGuesser,
  InputGuesser,
  ListGuesser,
  FieldGuesser,
  ShowGuesser,
  CreateGuesser
} from "@api-platform/admin";

const userRoles = [
  { id: 'ROLE_USER', name: 'ROLE_USER' },
  { id: 'ROLE_ADMIN', name: 'ROLE_ADMIN' },
  { id: 'ROLE_SUPER_ADMIN', name: 'ROLE_SUPER_ADMIN' },
]

export const UserList = props => (
  <ListGuesser {...props}>
    <FieldGuesser source={"username"} />
    <FieldGuesser source={"isPlaygroundUser"} />
    <FieldGuesser source={"enabled"} />
    <FieldGuesser source={"sessionsCompleted"} />
  </ListGuesser>
);

export const UserShow = props => (
  <ShowGuesser {...props}>
    <FieldGuesser source={"enabled"} addLabel={true} />
    <FieldGuesser source={"username"} addLabel={true} />
    <FieldGuesser source={"isPlaygroundUser"} addLabel={true} />
    <FieldGuesser source={"roles"} addLabel={true} />
    <FieldGuesser source={"sessionsCompleted"} addLabel={true} />
  </ShowGuesser>
);

export const UserEdit = props => (
  <EditGuesser {...props}>
    <InputGuesser source="enabled" />
    <InputGuesser source="username" />
    <InputGuesser source="isPlaygroundUser" />
    <InputGuesser source="sessionsCompleted" />
    <ArrayInput {...props} source="roles">
      <SimpleFormIterator>
        <SelectInput defaultValue="ROLE_USER" choices={userRoles} validate={required()} />
      </SimpleFormIterator>
    </ArrayInput>
    <PasswordInput source="plainPassword" label="New password" />
  </EditGuesser>
);

export const UserCreate = props => (
  <CreateGuesser {...props}>
    <InputGuesser source="enabled" />
    <InputGuesser source="username" />
    <InputGuesser source="isPlaygroundUser" />
    <ArrayInput {...props} source="roles">
      <SimpleFormIterator>
        <SelectInput defaultValue="ROLE_USER" choices={userRoles} validate={required()} />
      </SimpleFormIterator>
    </ArrayInput>
    <PasswordInput source="plainPassword" label="New password" validate={required()} />
  </CreateGuesser>
);
